import { render, staticRenderFns } from "./sidebar-terminplanung-header.vue?vue&type=template&id=391f0c60"
import script from "./sidebar-terminplanung-header.vue?vue&type=script&lang=js"
export * from "./sidebar-terminplanung-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports